interface VendorBadgeProps {
  name: string;
  active?: boolean;
  onClick?: () => void;
}

const VendorBadge = ({ name, active, onClick }: VendorBadgeProps) => {
  return (
    <button
      onClick={onClick}
      className={`rounded-md border px-3 py-1.5 text-xs font-mono font-medium transition-all ${
        active
          ? "border-primary/40 bg-primary/10 text-primary"
          : "border-border bg-secondary text-muted-foreground hover:text-foreground hover:border-border"
      }`}
    >
      {name}
    </button>
  );
};

export default VendorBadge;
